import { render, staticRenderFns } from "./reviewItem.vue?vue&type=template&id=2f2a0d22&"
import script from "./reviewItem.vue?vue&type=script&lang=js&"
export * from "./reviewItem.vue?vue&type=script&lang=js&"
import style0 from "./reviewItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports